import { render, staticRenderFns } from "./BannersTable.vue?vue&type=template&id=de38b04c&scoped=true&"
import script from "./BannersTable.vue?vue&type=script&lang=js&"
export * from "./BannersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de38b04c",
  null
  
)

export default component.exports